<template>
  <!-- style="opacity:0;position:absolute;" -->
  <div ref="barcode"
       style="text-align:center;"
       :style="{'height':height,'width':width}">
    <canvas ref="canvas"
            style="width:100%;height:100%;"></canvas>
  </div>
</template>
<script>
import { previewImg } from "@/util/pdf"
export default {
  props: {
    data: {
      type: String
    }
  },
  data () {
    return {
      height: '100%',
      width: '100%',
      id: ''
    }
  },
  watch: {
    data: {
      deep: true,
      handler () {
        this.id = this.data
        this.getCode()
      }
    }
  },
  mounted () {
    this.id = this.data
    this.getCode()
  },
  methods: {
    getCode () {
      PDF417.init(this.id);
      var barcode = PDF417.getBarcodeArray();
      var bw = 1;
      var bh = 1;
      var canvas = this.$refs.canvas;
      this.width = canvas.width = bw * barcode['num_cols'];
      this.height = canvas.height = bh * barcode['num_rows'];
      var ctx = canvas.getContext('2d');
      var y = 0;
      for (var r = 0; r < barcode['num_rows']; ++r) {
        var x = 0;
        // for each column
        for (var c = 0; c < barcode['num_cols']; ++c) {
          if (barcode['bcode'][r][c] == 1) {
            ctx.fillRect(x, y, bw, bh);
          }
          x += bw;
        }
        y += bh;
      }
      previewImg(this.$refs.canvas).then(res => {
        console.log(res)
        this.$emit("pdfImg", res)
      })
    }
  }

}

</script>
